// extracted by mini-css-extract-plugin
module.exports = {"button":"_3npmkdebVjKSwYjMcWL0iD primaryBackgroundColor buttonShadow","title":"_1-86oDbUcpPGGxItQkpS-j"};